module.exports = __webpack_public_path__ + "media/images/riders/small/DANIEL_MCCONNELL-df11ef0d20f210f0754f1fb4425adb96.png";